// extracted by mini-css-extract-plugin
export default {"container":"acc_3G0YU","inner":"acc_inn_2td8z","button":"acc_but_2-aqm","icon":"acc_ico_3AXrp","label":"acc_lab_268q5"};